import { jsx as n } from "react/jsx-runtime";
import '../../../assets/index18.css';const o = "_content_1mtez_1", c = {
  content: o
};
function s({ children: t }) {
  return /* @__PURE__ */ n("section", { className: c.content, children: t });
}
export {
  s as Content
};
